/** 底部tab 栏选项 */
// require('@/assets/images/icon/home_black.png')
export default [{
  pagePath: "/",
  text: "首推",
  iconName: "icon-shouye"
},
{
  pagePath: "/commission",
  text: "佣金",
  iconName: "icon-yongjin"
},
{
  pagePath: "/rank",
  text: "榜单",
  iconName: "icon-bangdan"
},
{
  pagePath: "https://jd.hkj168.com",
  text: "领取优惠",
  iconPath: require("@/assets/images/icon/coupon.png"),
  selectedIconPath: require("@/assets/images/icon/coupon_orange.png"),
  iconName: "icon-youhuiquan"
},
{
  pagePath: "/my",
  text: "我的",
  iconName: "icon-wode"
}]